/* FJUNA PDP: gallery (counter/thumbs), review slider, load more, sticky ATC, every add -> FJU brand cart drawer (never /cart) */
(function () {
  var tr = document.querySelector('[data-fju-track]'), thumbs = document.querySelector('[data-fju-thumbs]'), cnt = document.querySelector('[data-fju-gcount]');
  function go(k) { if (tr) tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' }); }
  function upd() {
    if (!tr) return;
    var n = tr.children.length, i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
    if (cnt) cnt.textContent = (i + 1) + ' / ' + n;
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
  }
  if (tr) {
    if (thumbs) thumbs.querySelectorAll('button').forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  document.querySelectorAll('[data-fju-rs]').forEach(function (c) {
    var t = c.querySelector('.fju-rs__track');
    c.querySelectorAll('.fju-rs__nav button').forEach(function (b) { b.addEventListener('click', function () { t.scrollBy({ left: +b.dataset.d * t.clientWidth * 0.85, behavior: 'smooth' }); }); });
  });
  var more = document.querySelector('[data-fju-more]'), list = document.querySelector('[data-fju-rlist]');
  if (more && list) more.addEventListener('click', function () { list.classList.add('is-all'); more.style.display = 'none'; });
  var form = document.getElementById('fju-buy');
  document.querySelectorAll('[data-fju-top]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault(); var t = document.querySelector('.kaching-bundles') || form;
      if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 110, behavior: 'smooth' });
    });
  });
  /* Kaching colour choice -> show that colour's hero (single colour, no image switch) */
  document.addEventListener('change', function (e) {
    var s = e.target; if (!s || !s.closest || !s.closest('.kaching-bundles') || s.tagName !== 'SELECT') return;
    var t = (s.options[s.selectedIndex] || {}).text || '';
    /* one colour */
  }, true);
  var st = document.querySelector('[data-fju-sticky]');
  if (st && form && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { st.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(form);
  }
  var sa = document.querySelector('[data-fju-sticky-atc]');
  if (sa && form) sa.addEventListener('click', function () {
    if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type=submit]').click();
  });
})();

/* Add to cart NEVER goes to /cart (Edvin 10-02): every /cart/add form opens the FJU brand cart drawer */
(function () {
  if (window.__fju_atc) return; window.__fju_atc = 1;
  function open() { if (window.FJU && window.FJU.openCart) return window.FJU.openCart(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function () { if (b) b.disabled = false; open(); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();


/* 10-06: back from the fallback POST (?opencart=1) -> open the FJUNA cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { if (window.FJU && window.FJU.openCart) { window.FJU.openCart(); clearInterval(t); } else if (++n > 40) clearInterval(t); }, 150);
})();

/* 10-12 SE: Kaching prints "1,399 kr" -> Swedish "1 399 kr" (text nodes inside .kaching-bundles only) */
(function () {
  var re = /(\d),(\d{3})(?=\s*kr)/g;
  function fix(root) {
    if (!root) return; var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) { if (re.test(n.nodeValue)) { re.lastIndex = 0; n.nodeValue = n.nodeValue.replace(re, '$1\u00a0$2'); } re.lastIndex = 0; }
  }
  function run() { document.querySelectorAll('.kaching-bundles').forEach(fix); }
  run(); var mo = new MutationObserver(function () { mo.disconnect(); run(); mo.observe(document.body, { childList: true, subtree: true, characterData: true }); });
  mo.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
